/**
 * Ryan O'Dowd
 * 2025-10-16
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Menu as PaperMenu,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const Item = (props: ItemProps & React.ComponentProps<typeof PaperMenu.Item>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperMenu.Item
      {...props}
      titleStyle={[props.textColor && {color: props.textColor}, props.isTextBold && styles.boldText]}
    />
  );
};

class ItemProps {

  isTextBold?: any;
  textColor?: any;
};

Item.displayName = 'Item';
export default Item;
